import React from 'react'
import { useTranslation } from 'react-i18next'
import { S } from '../locales/strings.js'

const bannerStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '32px',
  backgroundColor: '#FF8C00',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10000,
  pointerEvents: 'none',
}

const textStyle: React.CSSProperties = {
  color: '#FFFFFF',
  fontSize: '13px',
  fontWeight: 600,
  fontFamily: 'system-ui, sans-serif',
  letterSpacing: '0.5px',
  userSelect: 'none',
}

export const OfflineBanner: React.FC = () => {
  const { t } = useTranslation()
  const [isOnline, setIsOnline] = React.useState<boolean>(navigator.onLine)

  React.useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  if (isOnline) {
    return null
  }

  return (
    <div style={bannerStyle}>
      <span style={textStyle}>
        {t(S.OFFLINE_BANNER_TEXT)}
      </span>
    </div>
  )
}

export default OfflineBanner
